/**
 * Pure constants + tiny helpers shared by BulkTaxonomyDialog. Extracted to keep
 * the dialog focused on grid orchestration & API plumbing.
 */
export const MAX_ROWS = 500;

export const COLUMNS = [
  { key: "main_category", header: "Main Category", w: "min-w-[160px]" },
  { key: "sub_category", header: "Sub-Category", w: "min-w-[160px]" },
  { key: "issue_type", header: "Issue Type", w: "min-w-[200px]" },
  { key: "department", header: "Department", w: "min-w-[160px]", dropdown: "dept" },
  { key: "case_type", header: "Case Type", w: "min-w-[140px]", dropdown: "case" },
  { key: "priority", header: "Priority", w: "w-[110px]", dropdown: "priority" },
  { key: "sla_minutes", header: "SLA (min)", w: "w-[100px]", numeric: true },
  { key: "branch_required", header: "Branch req.", w: "w-[100px]", boolean: true },
];

export const PRIORITIES = ["low", "medium", "high", "critical"];

export const STATUS_DOT = {
  create: { color: "bg-emerald-500 ring-emerald-100", label: "Will create" },
  update: { color: "bg-blue-500 ring-blue-100", label: "Will update" },
  skip:   { color: "bg-slate-400 ring-slate-200", label: "Already exists / duplicate" },
  warn:   { color: "bg-amber-500 ring-amber-100", label: "Warning" },
  error:  { color: "bg-rose-500 ring-rose-100", label: "Has errors" },
};

export const DRAFT_KEY = "kippu_taxonomy_draft_v1";

let _ridCounter = 0;
export function emptyRow() {
  _ridCounter += 1;
  return {
    _rid: `r-${Date.now()}-${_ridCounter}`,
    main_category: "", sub_category: "", issue_type: "",
    department: "", case_type: "",
    priority: "medium", sla_minutes: "480", branch_required: "false",
  };
}
